export const privacyPolicyDefault = {
  title: "Privacy Policy – Superhost App",
  effective_date: "01 April 2026",
  last_updated: "01 April 2026",
  intro:
    "Superhost Cloud (\"we\", \"our\", \"us\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Superhost App and related services.",
  sections: [
    {
      heading: "Information We Collect",
      body:
        "We collect information you provide directly, such as your name, hotel/property name, mobile number, email address, city, state, and any details you share through forms or while using the app. We also collect limited technical information such as device type, app version, and usage activity that helps us operate and improve the service.",
    },
    {
      heading: "How We Use Your Information",
      body:
        "We use your information to provide and operate the app, manage your bookings and listings, respond to your enquiries, send important service updates, improve our features, and comply with legal obligations. We do not sell your personal information.",
    },
    {
      heading: "Data Protection",
      body:
        "We apply reasonable technical and organisational safeguards — including encryption in transit, access controls, and secure infrastructure — to protect your data against unauthorised access, loss, or misuse. While no method of transmission or storage is completely secure, we work continuously to protect your information.",
    },
    {
      heading: "App Permissions (Camera, Photos/Gallery, Notifications, Internet Access)",
      body:
        "The app may request the following permissions: Camera — to capture photos of your property or documents; Photos/Gallery — to upload existing images; Notifications — to send booking alerts and service updates; Internet Access — to sync your data with our servers. You can manage or revoke these permissions at any time through your device settings.",
    },
    {
      heading: "Data Sharing",
      body:
        "We share your information only as needed to provide the service — for example, with online travel agencies (OTAs) and channel partners to manage your listings, or with trusted service providers who process data on our behalf under strict confidentiality. We may also disclose information where required by law.",
    },
    {
      heading: "Notifications",
      body:
        "With your consent, we send push notifications and messages related to bookings, enquiries, reminders, and important account or service updates. You can opt out of non-essential notifications at any time through your device or app settings.",
    },
    {
      heading: "Identity Documents",
      body:
        "If you upload identity or verification documents (such as government IDs or business registration documents), these are used solely for verification and compliance purposes. They are stored securely and are not shared except as required to deliver the service or comply with the law.",
    },
    {
      heading: "Data Retention",
      body:
        "We retain your information for as long as your account is active or as needed to provide the service, comply with legal obligations, resolve disputes, and enforce our agreements. When data is no longer required, we securely delete or anonymise it.",
    },
    {
      heading: "Your Rights",
      body:
        "You have the right to access, correct, update, or request deletion of your personal information, and to withdraw consent where applicable. To exercise these rights, contact us using the details in the \"Contact Us\" section below.",
    },
    {
      heading: "Third-Party Services",
      body:
        "The app may integrate with third-party services (such as OTAs, payment processors, messaging platforms, and analytics providers). These services operate under their own privacy policies, and we encourage you to review them. We are not responsible for the practices of third parties.",
    },
    {
      heading: "Children's Privacy",
      body:
        "The Superhost App is intended for business users and is not directed to children under the age of 18. We do not knowingly collect personal information from children. If we become aware that we have collected such information, we will delete it promptly.",
    },
    {
      heading: "Location Information",
      body:
        "We may collect approximate location information (for example, your property's city and state) to display accurate listings and provide relevant features. We do not continuously track your precise location without your consent.",
    },
    {
      heading: "Data Ownership",
      body:
        "You retain ownership of the content and data you provide through the app. By using the service, you grant us a limited licence to process and use this data solely to operate and improve the service on your behalf.",
    },
    {
      heading: "Policy Updates",
      body:
        "We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. When we make material changes, we will update the \"Last Updated\" date and, where appropriate, notify you through the app or by email.",
    },
    {
      heading: "Contact Us",
      body:
        "If you have any questions, concerns, or requests regarding this Privacy Policy or your data, please contact us at:\nEmail: support@superhostcloud.com",
    },
    {
      heading: "Acceptance",
      body:
        "By downloading, accessing, or using the Superhost App, you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and handling of your information as described herein.",
    },
  ],
};
